import { useEffect } from 'react';

const STABLE_VIEWPORT = [
  'width=device-width',
  'initial-scale=1',
  'viewport-fit=cover'
].join(', ');

export default function useMobileViewportZoom() {
  useEffect(() => {
    let viewport = document.querySelector('meta[name="viewport"]');
    const createdViewport = !viewport;

    if (!viewport) {
      viewport = document.createElement('meta');
      viewport.name = 'viewport';
      document.head.appendChild(viewport);
    }

    const originalContent = viewport.getAttribute('content') || STABLE_VIEWPORT;

    // Never change viewport width from a resize callback. On tablets that
    // creates a layout/resize feedback loop and makes the page flicker.
    if (viewport.getAttribute('content') !== STABLE_VIEWPORT) {
      viewport.setAttribute('content', STABLE_VIEWPORT);
    }
    document.documentElement.classList.remove('mobile-default-zoom-60');

    return () => {
      document.documentElement.classList.remove('mobile-default-zoom-60');

      if (createdViewport) {
        viewport.remove();
      } else {
        viewport.setAttribute('content', originalContent);
      }
    };
  }, []);
}
